import { render, staticRenderFns } from "./ItemWriteComponent.vue?vue&type=template&id=a027973a&scoped=true"
import script from "./ItemWriteComponent.vue?vue&type=script&lang=js"
export * from "./ItemWriteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a027973a",
  null
  
)

export default component.exports